<ng-content select="phx-summary-value"></ng-content>
<ng-content select="phx-summary-label"></ng-content>
